// leaf-town - scenes: title, the git-log world map, the play scene and its HUD, pause, options, results
(function () {
  'use strict';
  const G = window.G, W = G.W, H = G.H, C = G.COL, K = C.ink, S = G.SPR, A = G.audio;
  const SV = () => G.save.data;
  const nodeIndex = (id) => G.NODES.indexOf(id);
  const isUnlocked = (i) => i === 0 || !!SV().cleared[G.NODES[i - 1]] || G.query.has('all');
  const commitHash = (id) => { let s = ''; for (let i = 0; i < 7; i++) s += '0123456789abcdef'[Math.floor(G.hash(i * 7 + id.charCodeAt(0), id.charCodeAt(2) * 3 + i, 5) * 16)]; return s; };

  // text with [KEY] caps inside it
  function richLines(text, maxW) {
    const lines = [[]];
    let w = 0;
    for (const word of text.split(' ')) {
      const m = /^\[([^\]]+)\](.*)$/.exec(word);
      const it = m ? { key: m[1], tail: m[2], w: Math.max(11, G.textW(m[1], { tiny: true }) + 6) + (m[2] ? G.textW(m[2]) + 1 : 0) } : { s: word, w: G.textW(word) };
      if (w + it.w > maxW && lines[lines.length - 1].length) { lines.push([]); w = 0; }
      lines[lines.length - 1].push(it); w += it.w + 4;
    }
    return lines;
  }
  function drawRich(ug, lines, x, y, col) {
    lines.forEach((ln, j) => {
      let cx = x;
      for (const it of ln) {
        if (it.key) { const kw = G.keycap(ug, cx, y + j * 13 - 2, it.key); if (it.tail) G.text(ug, it.tail, cx + kw + 1, y + j * 13, col); }
        else G.text(ug, it.s, cx, y + j * 13, col);
        cx += it.w + 4;
      }
    });
  }
  const richW = (lines) => lines.reduce((m, ln) => Math.max(m, ln.reduce((a, it) => a + it.w + 4, -4)), 0);

  // ---------- options (shared by title and pause) ----------
  function Options(onClose, canErase) {
    const items = [
      { k: 'music', label: 'music' }, { k: 'sfx', label: 'sound' }, { k: 'voice', label: 'voices' },
      { k: 'shake', label: 'screen shake', toggle: true }, { k: 'full', label: 'fullscreen', act: true },
    ];
    if (canErase) items.push({ k: 'erase', label: 'erase save', act: true });
    items.push({ k: 'back', label: 'back', act: true });
    let sel = 0, armed = false;
    return {
      update() {
        const I = G.input, o = SV().opt, it = items[sel];
        if (I.pressed.down) { sel = (sel + 1) % items.length; A.sfx('uiMove'); armed = false; }
        if (I.pressed.up) { sel = (sel + items.length - 1) % items.length; A.sfx('uiMove'); armed = false; }
        const dir = (I.pressed.right ? 1 : 0) - (I.pressed.left ? 1 : 0);
        if (dir && !it.act) {
          if (it.toggle) o[it.k] = o[it.k] ? 0 : 1; else o[it.k] = G.clamp(Math.round((o[it.k] + dir * 0.1) * 10) / 10, 0, 1);
          A.applyVolume(); A.sfx(it.k === 'voice' ? 'textSys' : 'uiMove');
        }
        if (I.ok) {
          if (it.toggle) { o[it.k] = o[it.k] ? 0 : 1; A.sfx('uiOk'); }
          else if (it.k === 'full') G.toggleFullscreen();
          else if (it.k === 'erase') { if (armed) { G.save.reset(); A.sfx('brk'); armed = false; onClose(true); } else { armed = true; A.sfx('warn'); } }
          else if (it.k === 'back') { G.save.write(); A.sfx('uiBack'); onClose(); }
        } else if (I.back) { G.save.write(); A.sfx('uiBack'); onClose(); }
      },
      draw(ug) {
        const pw = 196, ph = items.length * 14 + 30, x = (W - pw) / 2, y = (H - ph) / 2;
        ug.fillStyle = 'rgba(13,10,18,0.72)'; ug.fillRect(0, 0, W, H);
        G.panel(ug, x, y, pw, ph, '#17131f', C.paper, '#0d0a12');
        G.text(ug, 'OPTIONS', x + 10, y + 8, C.accent, { sp: 2 });
        items.forEach((it, i) => {
          const yy = y + 26 + i * 14, on = i === sel, o = SV().opt;
          if (on) { ug.fillStyle = '#2a2338'; ug.fillRect(x + 4, yy - 3, pw - 8, 13); G.text(ug, '▸', x + 8, yy, C.accent); }
          G.text(ug, it.k === 'erase' && armed && on ? 'really? press again' : it.label, x + 18, yy, on ? C.paper : C.dim);
          if (!it.act && !it.toggle) for (let b = 0; b < 10; b++) { ug.fillStyle = b < Math.round(o[it.k] * 10) ? (on ? C.accent : '#8a5a48') : '#3a3346'; ug.fillRect(x + pw - 74 + b * 6, yy + 1, 4, 6); }
          else if (it.toggle) G.text(ug, o[it.k] ? 'on' : 'off', x + pw - 14, yy, o[it.k] ? C.ok : C.dim, { align: 'r' });
        });
      },
    };
  }

  // ---------- the logo: 풀잎 마을 in chunky blocks, one block for every pixel of the Galmuri glyph ----------
  let LOGO = null;
  const logo = () => {
    if (LOGO || !G.kReady()) return LOGO;
    const U = 3, out = [], LF = '#7fd08a', LFHI = '#c6f2a8', LFLO = '#3f8a55';
    let x = 0;
    for (const ch of '풀잎 마을') {
      if (ch === ' ') { x += U * 4; continue; }
      const m = G.kGlyphs(ch, '#ffffff'), mw = m.width, mh = m.height, d = m.g.getImageData(0, 0, mw, mh).data;
      const on = (i, j) => i >= 0 && j >= 0 && i < mw && j < mh && d[(j * mw + i) * 4 + 3] > 0;
      let x0 = mw, x1 = -1;
      for (let j = 0; j < mh; j++) for (let i = 0; i < mw; i++) if (on(i, j)) { x0 = Math.min(x0, i); x1 = Math.max(x1, i); }
      const gw = x1 - x0 + 1, p = G.pix(gw * U + 4, mh * U + 4);
      for (let j = 0; j < mh; j++) for (let i = x0; i <= x1; i++) {
        if (!on(i, j)) continue;
        const px = 2 + (i - x0) * U, py = 2 + j * U;
        p.rect(px, py, U, U, LF);
        if (!on(i, j - 1)) p.rect(px, py, U, 1, LFHI);
        if (!on(i, j + 1)) p.rect(px, py + U - 1, U, 1, LFLO);
      }
      p.outline(K);
      const sh = G.makeCanvas(p.w, p.h + 2); sh.g.drawImage(G.tint(p.c, K), 0, 2); sh.g.drawImage(p.c, 0, 0);   // hard drop shadow
      out.push({ img: sh, x, w: gw * U });
      x += gw * U + U * 2;
    }
    return (LOGO = { letters: out, w: x - U * 2 });
  };
  const groundStrip = (() => { let c = null; return () => { if (!c) { c = G.makeCanvas(W + 32, 32); for (let i = 0; i < 26; i++) for (let j = 0; j < 2; j++) G.drawSolid(c.g, 1, i * 16, j * 16, i + 40, j + 3, { u: j > 0, d: true, l: true, r: true }); } return c; }; })();

  // =====================================================================
  // title
  // =====================================================================
  function Title(skipPress) {
    let t = 0, state = skipPress && A.ctx ? 'drop' : 'press', sel = 0, opts = null, confirm = false, dropT = 0, landed = 0;
    const items = () => (SV().started ? ['continue', 'new game', 'friend', 'options'] : ['new game', 'options']);
    const begin = () => { state = 'drop'; dropT = 0; landed = 0; A.music('title'); };
    return {
      enter() { A.intensity = 0; if (state === 'drop') begin(); },
      update(dt) {
        t += dt;
        const I = G.input;
        if (opts) { opts.update(dt); return; }
        if (state === 'press') { if (I.any) { A.unlock(); begin(); } return; }
        dropT += dt;
        const n = Math.min(4, Math.floor((dropT - 0.25) / 0.16 + 0.55));
        if (n > landed) { landed = n; A.sfx('stamp'); }
        if (state === 'drop' && dropT > 1.5) state = 'menu';
        if (state !== 'menu' || G.transitioning()) return;
        const it = items();
        if (confirm) {
          if (I.pressed.jump || I.pressed.start) { confirm = false; G.save.reset(); SV().started = true; G.save.write(); A.sfx('uiOk'); G.go(() => Pick(() => G.Town('town'))); }
          else if (I.pressed.attack || I.back) { confirm = false; A.sfx('uiBack'); }
          return;
        }
        if (I.pressed.down) { sel = (sel + 1) % it.length; A.sfx('uiMove'); }
        if (I.pressed.up) { sel = (sel + it.length - 1) % it.length; A.sfx('uiMove'); }
        if (I.ok) {
          const k = it[sel];
          A.sfx('uiOk');
          if (k === 'continue') G.go(() => (SV().name ? G.Town('town') : Pick(() => G.Town('town'))));   // a save from before names: ask once
          else if (k === 'new game') { if (SV().started) confirm = true; else { SV().started = true; G.save.write(); G.go(() => Pick(() => G.Town('town'))); } }
          else if (k === 'friend') G.go(() => Pick(() => Title(true)));
          else opts = Options(() => { opts = null; sel = Math.min(sel, items().length - 1); }, true);
        }
      },
      draw(g, ug) {
        G.drawBG('town', g, t * 9, 0, G.time, 0);
        G.ambient = '#aab2dc';
        const gs = groundStrip(), gx = -((t * 9 * 0.9) % 16);
        g.drawImage(gs, Math.round(gx), 184);
        // your friend, waiting
        const look = Math.sin(t * 0.7) > 0.3 ? 1 : -1, hop = state !== 'press' && (t % 5.2) < 0.4 ? -Math.sin(((t % 5.2) / 0.4) * Math.PI) * 9 : 0;
        G.drawHero(g, 84, 184 + hop, { u: 2, face: look, blink: (t % 3.3) < 0.13, legs: Math.sin(t * 2.6) > 0.55 && !hop ? [1, 1, 1, 1] : [2, 2, 2, 2], lift: Math.sin(t * 2.6) > 0.55 && !hop ? 1 : 0, armL: hop ? -2 : 0, armR: hop ? -2 : 0 });
        G.light(84, 170, 70, '#ffd9b8', 1, 0.14);
        if (state === 'press') {
          g.fillStyle = 'rgba(13,10,18,0.5)'; g.fillRect(0, 0, W, H);
          if (((t * 1.6) | 0) % 2) G.text(ug, G.input.touch ? 'tap to start' : 'click or press any key', W / 2, 104, C.paper, { align: 'c', outline: K });
          G.text(ug, 'headphones recommended', W / 2, 120, C.dim, { align: 'c', tiny: true });
          return;
        }
        // logo
        const LG = logo() || { w: 0, letters: [] }, lx = Math.round((W - LG.w) / 2) - 2, ly = 26;
        LG.letters.forEach((l, i) => {
          const u = G.clamp((dropT - 0.25 - i * 0.16) / 0.45, 0, 1);
          if (u <= 0) return;
          const y = ly - 110 * (1 - G.ease.bounce(u));
          ug.drawImage(l.img, lx + l.x, Math.round(y));
        });
        if (dropT > 1.25) {
          const sub = 'LEAF-TOWN', n = Math.min(sub.length, Math.floor((dropT - 1.25) * 16));
          const sw = G.textW(sub, { sp: 3 });
          G.text(ug, sub.slice(0, n), (W - sw) / 2, ly + 52, C.paper, { sp: 3, outline: K });
          if (((t * 2.5) | 0) % 2) { ug.fillStyle = '#7fd08a'; ug.fillRect(Math.round((W - sw) / 2 + G.textW(sub.slice(0, n), { sp: 3 }) + 4), ly + 52, 5, 7); }
        }
        G.light(W / 2, ly + 20, 150, '#d6ffb0', 0.6, 0.12);
        if (state === 'menu') {
          const it = items();
          it.forEach((s, i) => {
            const y = 118 + i * 15, on = i === sel;
            if (on) G.drawHero(ug, 236, y + 8 - Math.abs(Math.sin(t * 6)) * 2, { u: 1, face: 1 });
            G.text(ug, s, 250, y, on ? C.paper : '#8d8798', { outline: K });
          });
          if (confirm) { G.panel(ug, 92, 92, 200, 40, '#17131f', C.paper); G.text(ug, 'Start over? This erases your save.', W / 2, 100, C.paper, { align: 'c' }); G.text(ug, 'Z yes   X no', W / 2, 116, C.accentHi, { align: 'c' }); }
          G.text(ug, 'ARROWS + Z   •   F FULLSCREEN   •   M MUTE', W / 2, H - 10, '#6b6578', { align: 'c', tiny: true });
          if (SV().finished) G.text(ug, '✓ build passing', 8, 8, C.ok, { tiny: true });
        }
        if (opts) opts.draw(ug);
      },
    };
  }

  // =====================================================================
  // pick a friend
  // =====================================================================
  function Pick(next) {
    const N = G.CRITTERS.length, gap = 58, x0 = W / 2 - (gap * (N - 1)) / 2;
    let t = 0, hop = 0, asking = false, sel = Math.max(0, G.CRITTERS.findIndex((k) => k.id === SV().hero));
    return {
      update(dt) {
        t += dt; hop = Math.max(0, hop - dt);
        if (G.transitioning() || asking) return;
        const I = G.input, dir = (I.pressed.right ? 1 : 0) - (I.pressed.left ? 1 : 0);
        if (dir) { sel = (sel + dir + N) % N; hop = 0.32; A.sfx('uiMove'); }
        if (I.ok) {
          // second step: the name box (DOM, locks the game keys while open). Esc in the box comes back here.
          A.sfx('uiOk'); asking = true;
          G.askName(SV().name, (name) => { asking = false; if (name === null) return; SV().hero = G.CRITTERS[sel].id; SV().name = name; G.save.write(); G.go(next); });
        }
        else if (I.back) { A.sfx('uiBack'); G.go(() => Title(true)); }
      },
      draw(g, ug) {
        G.drawBG('town', g, 40 + t * 6, 0, G.time, 0);
        G.ambient = '#aab2dc';
        g.drawImage(groundStrip(), -Math.round((t * 6 * 0.9) % 16), 184);
        G.CRITTERS.forEach((k, i) => {
          const on = i === sel, x = Math.round(x0 + i * gap), h = on && hop > 0 ? -Math.sin((hop / 0.32) * Math.PI) * 10 : 0;
          const breathe = Math.sin(t * 2.6 + i) > 0.55 && !h;
          G.drawCritter(g, x, 184 + h, { kind: k.id, u: 2, face: on ? 1 : i < sel ? 1 : -1, blink: ((t + i * 0.7) % 3.3) < 0.13, lift: breathe ? 1 : 0, legs: breathe ? [1, 1, 1, 1] : [2, 2, 2, 2], armL: h ? -2 : 0, armR: h ? -2 : 0 });
          G.light(x, 166, on ? 64 : 34, on ? '#ffe6d0' : '#cfe0ff', on ? 1 : 0.5, on ? 0.18 : 0.05);
          G.ktext(ug, k.ko, x, 194, on ? C.paper : C.dim, { align: 'c', outline: K });
          if (on) { const ay = 134 - Math.round(Math.abs(Math.sin(t * 4)) * 2); ug.fillStyle = K; ug.fillRect(x - 5, ay - 1, 11, 1); for (let j = 0; j < 5; j++) ug.fillRect(x - 4 + j, ay + j, 9 - j * 2, 1); ug.fillStyle = C.paper; for (let j = 0; j < 4; j++) ug.fillRect(x - 3 + j, ay + j, 7 - j * 2, 1); }
        });
        const k = G.CRITTERS[sel];
        G.ktext(ug, '함께할 친구를 골라요', W / 2, 30, C.paper, { align: 'c', outline: K });
        G.text(ug, k.en.toUpperCase(), W / 2, 50, k.col, { align: 'c', sp: 2, outline: K });
        G.keycap(ug, W / 2 - 54, 72, '<'); G.keycap(ug, W / 2 - 41, 72, '>'); G.text(ug, 'choose', W / 2 - 26, 74, C.dim);
        G.keycap(ug, W / 2 + 18, 72, 'Z'); G.text(ug, 'ok', W / 2 + 33, 74, C.dim);
      },
    };
  }

  // =====================================================================
  // world map: git log --graph
  // =====================================================================
  let previewC = null;
  function MapScene() {
    const N = G.NODES.length;
    let sel = G.clamp(SV().node || 0, 0, N - 1), t = 0, scroll = sel, heroY = sel, moved = 0;
    while (sel > 0 && !isUnlocked(sel)) sel--;
    const ROW = 18, TX = 24, BX = 42, baseY = 124;
    const yOf = (i) => baseY - (i - scroll) * ROW;
    return {
      enter() { A.music('map'); A.intensity = 0; scroll = heroY = sel; },
      update(dt) {
        t += dt; moved -= dt;
        scroll = G.damp(scroll, sel, 10, dt); heroY = G.damp(heroY, sel, 14, dt);
        if (G.transitioning()) return;
        const I = G.input;
        const dir = (I.pressed.up ? 1 : 0) - (I.pressed.down ? 1 : 0);
        if (dir) {
          const n = sel + dir;
          if (n >= 0 && n < N && isUnlocked(n)) { sel = n; moved = 0.2; A.sfx('uiMove'); } else A.sfx('uiBack');
        }
        if (I.ok) { SV().node = sel; G.save.write(); A.sfx('uiOk'); G.startLevel(G.NODES[sel]); }
        else if (I.pressed.pause) { A.sfx('uiBack'); G.go(() => G.Town('town', 'map')); }
      },
      draw(g, ug) {
        const id = G.NODES[sel], def = G.LEVELS[id], th = G.THEME[def.world];
        g.fillStyle = '#131019'; g.fillRect(0, 0, W, H);
        g.fillStyle = '#17131f'; g.fillRect(0, 0, 196, H);
        for (let y = ((-scroll * ROW) % 36 + 36) % 36; y < H; y += 36) { g.fillStyle = '#1b1724'; g.fillRect(0, Math.round(y), 196, 18); }
        // graph lines
        const trunkCol = '#5a5568';
        g.fillStyle = trunkCol; g.fillRect(TX, Math.max(0, Math.round(yOf(N) - 6)), 1, Math.round(yOf(-1)) - Math.max(0, Math.round(yOf(N) - 6)));
        let prevTrunk = -1;
        for (let i = 0; i < N; i++) {
          const d = G.LEVELS[G.NODES[i]], col = G.THEME[d.world].accent, y = Math.round(yOf(i));
          if (d.boss) { prevTrunk = i; continue; }
          const first = i === 0 || G.LEVELS[G.NODES[i - 1]].boss, nextBoss = i + 1 < N && G.LEVELS[G.NODES[i + 1]].boss;
          const lit = isUnlocked(i) ? col : '#3a3346';
          if (first) G.line(g, TX, Math.round(yOf(prevTrunk)), BX, y, lit);
          else { g.fillStyle = lit; g.fillRect(BX, y, 1, ROW); }
          if (nextBoss) G.line(g, BX, y, TX, Math.round(yOf(i + 1)), SV().cleared[G.NODES[i]] ? col : '#3a3346');
        }
        // nodes + labels
        const friendsAt = G.presence.stageFriends();   // who is running each stage right now (G.presence): join the same one
        G.disc(g, TX, yOf(-1), 2, trunkCol); G.text(g, 'initial commit', 62, yOf(-1) - 3, '#4a4458');
        for (let i = 0; i < N; i++) {
          const nid = G.NODES[i], d = G.LEVELS[nid], y = Math.round(yOf(i));
          if (y < -10 || y > H + 10) continue;
          const col = G.THEME[d.world].accent, x = d.boss ? TX : BX, open = isUnlocked(i), done = !!SV().cleared[nid];
          if (done) { G.disc(g, x, y, d.boss ? 4 : 3, col); G.disc(g, x, y, 1, '#17131f'); }
          else if (open) { G.disc(g, x, y, d.boss ? 4 : 3, '#17131f'); G.ring(g, x, y, d.boss ? 4 : 3, col); if (((t * 3) | 0) % 2) G.ring(g, x, y, d.boss ? 6 : 5, G.rgba(col, 0.5)); }
          else G.disc(g, x, y, 2, '#3a3346');
          const on = i === sel;
          G.text(g, !open ? '???????' : d.boss ? 'MERGE' : commitHash(nid), 62, y - 3, on ? '#8d8798' : '#4a4458', { tiny: true });
          const label = open ? d.name : 'locked';
          G.text(g, label, 96, y - 4, on ? C.paper : open ? (d.boss ? col : done ? '#a9a2b6' : '#c9c2d6') : '#4a4458');
          const fr = friendsAt[nid];
          if (fr) { G.disc(g, 7, y, 3, fr[0].col); G.ring(g, 7, y, 4, C.paper); G.text(g, '' + fr.length, 13, y - 3, C.paper, { tiny: true }); }   // a dot in your friend's colour and how many are in that stage
          if (open && !d.boss) { const sp = SV().sparks[nid] || []; for (let k = 0; k < 3; k++) { g.fillStyle = sp[k] ? C.leafMid : '#3a3346'; g.fillRect(183 + k * 4, y - 1, 2, 2); } }
        }
        if (SV().finished) { G.text(g, 'tag: v1.0', 62, yOf(N) - 3, C.ok); G.disc(g, TX, yOf(N), 3, C.ok); }
        // your friend rides the selected commit
        const cd = G.LEVELS[G.NODES[Math.round(heroY)]], cxp = cd.boss ? TX : BX;
        G.drawHero(g, cxp, Math.round(yOf(heroY)) - 5 - (moved > 0 ? Math.sin((moved / 0.2) * Math.PI) * 5 : Math.abs(Math.sin(t * 3)) * 1.5), { u: 1, face: 1, blink: (t % 3) < 0.12 });
        // header
        g.fillStyle = '#131019'; g.fillRect(0, 0, 196, 16); g.fillStyle = '#2a2338'; g.fillRect(0, 16, 196, 1);
        G.text(g, '$ git log --graph', 8, 5, '#7dff9a', { tiny: true });
        G.text(g, '❦ ' + G.save.sparkCount(), 188, 5, C.leaf, { tiny: true, align: 'r' });
        g.fillStyle = '#2a2338'; g.fillRect(196, 0, 1, H);
        // preview pane
        if (!previewC) previewC = G.makeCanvas(W, H);
        const keep = G.lights.length;
        G.drawBG(def.world, previewC.g, 120 + t * 6, 0, G.time, 0);
        G.lights.length = keep;
        const px = 208, py = 14, pw = 164, ph = 84;
        G.panel(g, px - 2, py - 2, pw + 4, ph + 4, '#0d0a12', '#3a3346');
        g.drawImage(previewC, 110, 96, pw, ph, px, py, pw, ph);
        if (def.boss) { g.fillStyle = 'rgba(13,10,18,0.45)'; g.fillRect(px, py, pw, ph); G.text(g, 'BOSS', px + pw / 2, py + 30, C.hazardHi, { align: 'c', sp: 4, outline: K }); G.text(g, def.name, px + pw / 2, py + 44, C.paper, { align: 'c', outline: K }); }
        G.text(g, 'WORLD ' + def.world + ' • ' + th.name, px, py + ph + 8, th.accent, { tiny: true });
        G.text(g, def.boss ? def.name : th.path + '/' + def.name, px, py + ph + 18, C.paper);
        G.wrap(def.blurb || '', pw).slice(0, 4).forEach((ln, i) => G.text(g, ln, px, py + ph + 32 + i * 10, '#8d8798'));
        const done = SV().cleared[id], yb = H - 34, here = friendsAt[id];
        if (here) G.ktext(ug, ('지금 함께: ' + here.map((f) => f.name).join(', ')).slice(0, 22), px, yb - 18, '#c6f2a8', { outline: K });
        G.text(g, done ? '✓ passing' : '✗ failing', px, yb, done ? C.ok : C.bad);
        if (SV().best[id]) G.text(g, 'best ' + G.fmtTime(SV().best[id]), px + pw, yb, C.dim, { align: 'r' });
        if (!def.boss) { const sp = SV().sparks[id] || []; for (let k = 0; k < 3; k++) g.drawImage((sp[k] ? S.leaf : S.leafGhost)[0], px + 62 + k * 13, yb - 4); }
        G.text(g, th.time + ' AM', px + pw, 4, '#6b6578', { tiny: true, align: 'r' });
        G.keycap(g, px, H - 17, 'Z'); G.text(g, 'checkout', px + 15, H - 14, C.dim); G.keycap(g, px + 78, H - 17, 'ESC'); G.text(g, 'town', px + 101, H - 14, C.dim);
        G.ambient = null;
      },
    };
  }

  G.startLevel = (id, snap) => {
    const def = G.LEVELS[id], key = 'w' + def.world;
    if (/-1$/.test(id) && !SV().seen[key] && !snap) G.go(() => G.CUT.world(def.world, () => { SV().seen[key] = true; G.save.write(); G.go(() => Play(id)); }));
    else G.go(() => Play(id, snap));
  };

  // =====================================================================
  // play
  // =====================================================================
  const BOSS_LINES = { null: ['null_intro'], merge: ['head_intro', 'theirs_intro'], leak: ['leak_intro'], loop: ['loop_intro'], mono: ['mono_intro'] };
  const FAILS = ['Segmentation fault (core dumped)', 'Process exited with code 1', 'Uncaught exception: hero is undefined', 'panic: runtime error', 'Killed: 9'];
  function Play(id, snap) {
    const def = G.LEVELS[id], L = new G.Level(def, snap), th = L.th, p = L.player;
    const cap = new G.Caption();
    let state = 'play', t = 0, wait = 0, sel = 0, opts = null, intro = null, res = null, failMsg = '', bars = 0, hpShake = 0, lastHp = p.hp, tokPop = 0, lastTok = L.tokens;
    const say = (vid) => G.speak(cap, vid);
    // other people in this same stage (G.presence): they run alongside, translucent; no collision, no damage, enemies/items/deaths stay each player's own
    let friends = [];
    L.others = (g, cx, cy) => { for (const o of friends) { const x = o.x - cx, y = o.y - cy; if (x > -24 && x < W + 24 && y > -24 && y < H + 24) G.drawCritter(g, x, y, o.pose); } };
    const startFight = () => { state = 'play'; p.frozen = false; L.boss.start(); SV().seen['b' + id] = true; G.save.write(); A.music(def.boss === 'mono' ? 'final' : 'boss', { fade: 0.3 }); cap.text = ''; };
    const finish = () => {
      const d = SV(), sp = d.sparks[id] || [false, false, false];
      d.cleared[id] = true;
      L.sparks.forEach((s, i) => { if (s) sp[i] = true; });
      d.sparks[id] = sp;
      const best = !d.best[id] || L.clock < d.best[id];
      if (best) d.best[id] = L.clock;
      d.tokens += L.tokens; d.node = Math.min(G.NODES.length - 1, nodeIndex(id) + 1);
      G.save.write();
      const rows = [];
      rows.push([def.boss ? 'conflict resolved' : 'reached the exit', G.fmtTime(L.clock), 1]);
      rows.push(['coins', def.boss ? String(L.tokens) : L.tokens + (L.tokTotal ? ' / ' + L.tokTotal : ''), 1]);
      if (!def.boss) rows.push(['leaves', L.sparks, L.sparks.every(Boolean) ? 1 : 0]);
      rows.push([L.hits ? 'hits taken: ' + L.hits : 'no hits taken', '', L.hits ? 0 : 1]);
      res = { rows, best, shown: 0, t: 0 };
      state = 'clear'; p.frozen = true; p.celebrate = true; p.vx = 0;
      A.music('clear'); G.voice.warm(['sys_pass']); setTimeout(() => G.voice.play('sys_pass'), 900);
    };
    const leave = () => {
      const d = SV();
      if (def.boss && def.reward && !d.tools[def.reward]) { d.tools[def.reward] = true; G.save.write(); G.go(() => G.CUT.tool(def.reward, () => G.go(() => MapScene()))); }
      else if (id === G.NODES[G.NODES.length - 1]) { d.finished = true; G.save.write(); G.go(() => G.CUT.ending(() => G.go(() => Title(true))), { speed: 1.2, col: '#ffffff' }); }
      else G.go(() => MapScene());
    };
    return {
      L,
      enter() {
        A.intensity = 0;
        if (L.boss) {
          p.frozen = true; state = 'bossIntro';
          const seen = SV().seen['b' + id];
          intro = { lines: seen ? [] : BOSS_LINES[def.boss].slice(), t: 0, lineT: seen ? 1.5 : 1.3, quick: seen };
          G.voice.warm(BOSS_LINES[def.boss].concat([def.boss + '_p2', def.boss + '_die', 'head_alone', 'theirs_alone', 'head_die', 'theirs_die', 'mono_p3'].filter((v) => G.voice.has(v))));
          A.music('tension');
        } else A.music(def.music || th.music);
      },
      stage: id,        // the net bridge (client/1-endpoints/net/presence.ts, G.onScene) puts me into this stage for everyone running it
      update(dt) {
        const I = G.input;
        G.presence.update(dt, { x: p.x + p.w / 2, y: p.y + p.h, face: p.face, vx: p.vx, vy: p.vy, ground: p.onGround, dashT: p.dashT, sit: null });   // tell the others where I am, move them
        friends = G.presence.stagePeers();
        if (opts) { opts.update(dt); return; }
        if (state === 'paused') {
          const items = 5;
          if (I.pressed.pause || I.pressed.start && sel === 0) { state = 'play'; A.sfx('pause'); A.duck(1); return; }
          if (I.pressed.down) { sel = (sel + 1) % items; A.sfx('uiMove'); }
          if (I.pressed.up) { sel = (sel + items - 1) % items; A.sfx('uiMove'); }
          if (I.pressed.jump || I.pressed.attack || I.pressed.start) {
            A.sfx('uiOk'); A.duck(1);
            if (sel === 0) state = 'play';
            else if (sel === 1) G.go(() => Play(id, def.boss ? null : L.snapshot()));
            else if (sel === 2) opts = Options(() => { opts = null; });
            else if (sel === 3) G.go(() => MapScene());
            else G.go(() => G.Town('town', 'map'));      // quitting keeps saved progress, same as going back to git log
          }
          return;
        }
        t += dt; cap.update(dt);
        bars = G.damp(bars, state === 'bossIntro' || (L.boss && L.boss.dying) ? 1 : 0, 6, dt);
        if (hpShake > 0) hpShake -= dt;
        if (p.hp < lastHp) hpShake = 0.4;
        lastHp = p.hp;
        if (L.tokens !== lastTok) { tokPop = 0.15; lastTok = L.tokens; }
        if (tokPop > 0) tokPop -= dt;

        if (state === 'bossIntro') {
          intro.t += dt; intro.lineT -= dt;
          const tap = (I.pressed.jump || I.pressed.attack || I.pressed.start) && intro.t > 0.6;
          if (intro.lineT <= 0 || tap) {
            if (tap) G.voice.stop();
            if (intro.lines.length) { intro.lineT = say(intro.lines.shift()) + 0.2; if (intro.t < 2) A.sfx('roar'); }
            else startFight();
          }
        } else if (state === 'play') {
          if ((I.pressed.pause || I.pressed.start) && !p.dead && !G.transitioning()) { state = 'paused'; sel = 0; A.sfx('pause'); A.duck(0.35); return; }
        }
        L.update(dt);
        for (const ev of L.events.splice(0)) {
          if (ev === 'death' && state !== 'dead') {
            state = 'dead'; wait = 1.5; failMsg = G.pick(FAILS);
            SV().deaths++; G.save.write();
            A.stopMusic(0.3); const v = 'sys_fail' + G.randi(1, 3); G.voice.warm([v]); setTimeout(() => G.voice.play(v), 500);
          } else if (ev === 'exit') { A.sfx('gate'); finish(); }
          else if (ev === 'bossPhase') {
            A.intensity = 1;
            // a coffee break between phases
            const cy = def.boss === 'leak' ? 62 : 150;
            L.items.push({ kind: 'coffee', x: W / 2, y: cy, ph: 0 }); L.ring(W / 2, cy, 2, 20, C.paper, 0.4); L.pop(W / 2, cy - 14, 'coffee break', C.paper);
            if (def.boss === 'merge') say(L.boss.alone.def.voice + '_alone'); else say(def.boss + '_p2');
          } else if (ev === 'bossPhase3') { if (def.boss === 'mono') { say('mono_p3'); A.music('final2', { fade: 0.4 }); } }
          else if (ev === 'bossDying') { A.stopMusic(0.2); say(def.boss === 'merge' ? L.boss.last.def.voice + '_die' : def.boss + '_die'); p.inv = 99; }
          else if (ev === 'bossDead') { state = 'bossDown'; wait = 2.6; }
        }
        if (state === 'dead') { wait -= dt; if (wait <= 0 && !G.transitioning()) G.go(() => Play(id, def.boss ? null : L.snapshot())); }
        else if (state === 'bossDown') { wait -= dt; if (wait <= 0) finish(); }
        else if (state === 'clear') {
          res.t += dt;
          const n = Math.min(res.rows.length + 1, Math.floor((res.t - 0.7) / 0.38));
          if (n > res.shown) { res.shown = n; A.sfx(n <= res.rows.length ? 'tick' : 'uiOk'); }
          if (res.shown > res.rows.length && (I.pressed.jump || I.pressed.start || I.pressed.attack) && !G.transitioning()) { A.sfx('uiOk'); leave(); }
        }
      },
      draw(g, ug) {
        L.draw(g);
        // ----- names over the friends running this stage (their own colour, so they never read as enemies) -----
        for (const o of friends) {
          const x = Math.round(o.x - L.cx), y = Math.round(o.y - L.cy - 30);
          if (x < -40 || x > W + 40 || y < -12 || y > H + 12) continue;
          G.ktext(ug, o.name, x, y, o.col, { align: 'c', outline: K });
          if (o.mic) { const mx = x - Math.round(G.ktextW(o.name) / 2) - 7; ug.fillStyle = K; ug.fillRect(mx, y + 2, 5, 5); ug.fillStyle = '#7dff9a'; ug.fillRect(mx + 1, y + 3, 3, 3); }
        }
        // ----- HUD -----
        if (bars > 0.01) { ug.fillStyle = '#0d0a12'; ug.fillRect(0, 0, W, Math.round(18 * bars)); ug.fillRect(0, H - Math.round(18 * bars), W, 20); }
        const hudY = 6 - Math.round(bars * 26);
        for (let i = 0; i < p.maxHp; i++) {
          const jx = hpShake > 0 ? Math.round(Math.sin(t * 90 + i) * 1.5) : 0, low = p.hp === 1 && i === 0 && ((t * 4) | 0) % 2;
          ug.drawImage(i < p.hp ? (low ? G.tint(S.pip, '#ffffff') : S.pip) : S.pipOff, 6 + i * 9 + jx, hudY);
        }
        if (p.tools.agents) {
          const full = p.meter >= 100, act = p.agents.length > 0;
          G.panel(ug, 6, hudY + 11, 46, 5, '#231d2e', K);
          ug.fillStyle = act ? '#ffe2c4' : full ? (((t * 6) | 0) % 2 ? '#ffffff' : C.accentHi) : C.accent;
          ug.fillRect(8, hudY + 13, Math.round(42 * (act ? p.agents[0].life / 11 : p.meter / 100)), 1);
          if (full && !act) G.keycap(ug, 55, hudY + 8, 'V');
        }
        const tk = String(L.tokens), tw = G.textW(tk);
        ug.drawImage(S.token[0], W - 20 - tw, hudY - 1 - (tokPop > 0 ? 1 : 0)); G.text(ug, tk, W - 8, hudY, tokPop > 0 ? C.goldHi : C.paper, { align: 'r', outline: K });
        if (!def.boss) L.sparks.forEach((s, i) => { const had = (SV().sparks[id] || [])[i]; ug.drawImage(S.leafSm[s ? 0 : had ? 1 : 2], W - 37 + i * 10, hudY + 10); });
        // level name tab
        if (t < 3.2 && !def.boss) {
          const k = G.ease.out(G.clamp(t / 0.4, 0, 1)) * (1 - G.ease.in(G.clamp((t - 2.7) / 0.5, 0, 1)));
          const label = th.path + '/' + def.name, w = G.textW(label) + 22;
          G.panel(ug, Math.round(-w + (w + 6) * k), 30, w, 15, '#17131f', '#3a3346');
          ug.fillStyle = th.accent; ug.fillRect(Math.round(-w + (w + 6) * k) + 2, 31, 2, 13);
          G.text(ug, label, Math.round(-w + (w + 6) * k) + 9, 34, C.paper);
        }
        // sign bubbles
        if (L.sign && state === 'play') {
          const lines = richLines(L.sign.text, 196), bw = richW(lines) + 12, bh = lines.length * 13 + 7;
          const x = Math.round(G.clamp(L.sign.x - L.cx - bw / 2, 4, W - bw - 4)), y = Math.max(22, Math.round(L.sign.y - L.cy - 24 - bh));
          G.panel(ug, x, y, bw, bh, '#17131f', C.paper, '#0d0a12');
          ug.fillStyle = C.paper; ug.fillRect(G.clamp(L.sign.x - L.cx, x + 4, x + bw - 6), y + bh, 3, 2);
          drawRich(ug, lines, x + 6, y + 6, C.paper);
        }
        // boss
        if (L.boss && (state === 'play' || state === 'paused') && !L.boss.dead) {
          const b = L.boss, bw = 190, x = (W - bw) / 2, y = H - 12;
          G.text(ug, b.name, x, y - 9, C.paper, { tiny: true, outline: K });
          G.panel(ug, x - 2, y - 2, bw + 4, 7, '#231d2e', K);
          ug.fillStyle = '#5a1630'; ug.fillRect(x, y, bw, 3);
          ug.fillStyle = b.flash > 0 ? '#ffffff' : C.hazard; ug.fillRect(x, y, Math.round(bw * Math.max(0, b.hp) / b.maxHp), 3);
          ug.fillStyle = '#ff9aab'; ug.fillRect(x, y, Math.round(bw * Math.max(0, b.hp) / b.maxHp), 1);
        }
        if (state === 'bossIntro' && L.boss) {
          const k = G.ease.out(G.clamp((intro.t - 0.3) / 0.5, 0, 1));
          if (k > 0) {
            G.text(ug, L.boss.name, W / 2, 40 - (1 - k) * 12, C.paper, { align: 'c', scale: 2, outline: K, shadow: K });
            ug.fillStyle = C.hazard; ug.fillRect(Math.round(W / 2 - 70 * k), 60, Math.round(140 * k), 1);
            G.text(ug, L.boss.sub, W / 2, 65, C.hazardHi, { align: 'c', outline: K });
          }
        }
        if (cap.text && !cap.done) {
          const lines = G.wrap(cap.text, W - 56), y = state === 'bossIntro' ? H - 46 : H - 40;
          ug.fillStyle = 'rgba(13,10,18,0.7)'; ug.fillRect(20, y - 16 - (lines.length - 1) * 5, W - 40, 14 + lines.length * 11);
          cap.draw(ug, y);
        }
        if (state === 'dead' && wait < 1.0) {
          ug.fillStyle = 'rgba(13,10,18,0.55)'; ug.fillRect(0, 92, W, 26);
          G.text(ug, failMsg, W / 2, 97, C.hazardHi, { align: 'c', outline: K });
          G.text(ug, 'RESTORING LAST COMMIT', W / 2, 109, C.dim, { align: 'c', tiny: true });
        }
        if (state === 'clear') this.drawResults(ug);
        if (state === 'paused') {
          ug.fillStyle = 'rgba(13,10,18,0.72)'; ug.fillRect(0, 0, W, H);
          G.panel(ug, 112, 48, 160, 124, '#17131f', C.paper, '#0d0a12');
          G.text(ug, 'PAUSED', 122, 56, C.accent, { sp: 2 }); G.text(ug, 'esc to resume', 262, 58, '#6b6578', { tiny: true, align: 'r' });
          ['resume', 'retry from last commit', 'options', 'back to git log', '마을로 가기'].forEach((s, i) => { const on = i === sel, y = 76 + i * 14; if (on) { ug.fillStyle = '#2a2338'; ug.fillRect(116, y - 3, 152, 13); G.text(ug, '▸', 120, y, C.accent); } if (i === 4) G.ktext(ug, s, 130, y - 2, on ? C.paper : C.dim); else G.text(ug, s, 130, y, on ? C.paper : C.dim); });
          const tl = SV().tools;
          G.text(ug, 'Z JUMP  X SWIPE' + (tl.bash ? '  C BASH' : '') + (tl.agents ? '  V FIREFLIES' : ''), W / 2, 156, '#6b6578', { tiny: true, align: 'c' });
          if (opts) opts.draw(ug);
        }
      },
      drawResults(ug) {
        const k = G.ease.out(G.clamp(res.t / 0.45, 0, 1)), pw = 232, ph = 40 + res.rows.length * 14 + 18, x = (W - pw) / 2, y = Math.round(40 + (1 - k) * 30);
        ug.fillStyle = G.rgba('#0d0a12', 0.5 * k); ug.fillRect(0, 0, W, H);
        ug.globalAlpha = k;
        G.panel(ug, x, y, pw, ph, '#101a14', '#7fd08a', '#0a120d');
        ug.fillStyle = C.ok; ug.fillRect(x + 8, y + 8, 30, 11); G.text(ug, 'PASS', x + 11, y + 10, '#0a1a0a');
        G.text(ug, (def.boss ? 'merge: ' : th.path + '/') + def.name, x + 44, y + 10, C.paper);
        res.rows.forEach((r, i) => {
          if (i >= res.shown) return;
          const yy = y + 28 + i * 14;
          G.text(ug, r[2] ? '✓' : '•', x + 12, yy, r[2] ? C.ok : C.dim);
          G.text(ug, r[0], x + 24, yy, r[2] ? '#d6ffd0' : '#a9a2b6');
          if (Array.isArray(r[1])) r[1].forEach((s, j) => ug.drawImage((s ? S.leaf : S.leafGhost)[0], x + pw - 52 + j * 14, yy - 4));
          else { const wv = G.textW(r[1]); ug.fillStyle = '#2a4a34'; for (let dx = x + 28 + G.textW(r[0]); dx < x + pw - 16 - wv; dx += 4) ug.fillRect(dx, yy + 5, 1, 1); G.text(ug, r[1], x + pw - 12, yy, C.paper, { align: 'r' }); }
        });
        if (res.shown > res.rows.length) {
          const yy = y + 30 + res.rows.length * 14;
          if (res.best) G.text(ug, 'new best time', x + 12, yy, C.gold);
          if (((res.t * 2) | 0) % 2) { G.keycap(ug, x + pw - 66, yy - 3, 'Z'); G.text(ug, 'commit', x + pw - 12, yy, C.okHi, { align: 'r' }); }
        }
        ug.globalAlpha = 1;
      },
    };
  }

  G.Scenes = {
    title: Title, map: MapScene, play: Play, pick: Pick,
    boot() {
      const q = G.query;
      if (q.has('place')) return G.Town(q.get('place') || 'town');
      if (q.has('pick')) return Pick(() => G.Town('town'));
      if (q.has('level')) return Play(q.get('level'));
      if (q.has('map')) return MapScene();
      if (q.has('cut')) { const c = q.get('cut'); return c === 'intro' ? G.CUT.intro(() => G.go(() => MapScene())) : c === 'ending' ? G.CUT.ending(() => G.go(() => Title(true))) : c[0] === 'w' ? G.CUT.world(+c[1], () => G.go(() => MapScene())) : G.CUT.tool(c, () => G.go(() => MapScene())); }
      return Title(false);
    },
  };
})();

